import { render } from "./inbox-actions.vue?vue&type=template&id=dd02a9a8"
import script from "./inbox-actions.vue?vue&type=script&lang=js"
export * from "./inbox-actions.vue?vue&type=script&lang=js"

import exportComponent from "/usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__